import { Location } from 'slate';

export const cleanState = {
  context: {
    entities: {},
  },
  value: [
    {
      children: [
        {
          text: '',
        },
      ],
    },
  ],
};

export const startLocation: Location = {
  anchor: { path: [0, 0], offset: 0 },
  focus: { path: [0, 0], offset: 0 },
};
